export default __webpack_public_path__ + "static/media/tropicanaLogo.0b1f124b.png";